export default {
    navName: 'PagesControl',
    crumb: ['实时数据'],
    batt: {
        dev_id: '',
        dev_name: '',
        analog_count: 0,
        state_count: 0,
        switch_count: 0,
    },
}